import React from "react"
import { createRoot, type Root } from "react-dom/client"
import { WalletAttributionCard } from "../components/WalletAttributionCard"

export const WalletCard = {
  _root: null as Root | null,

  mounted(this: typeof WalletCard & { el: HTMLElement; handleEvent: Function }) {
    this._root = createRoot(this.el)
    this._render()
    this.handleEvent("wallet:update", () => this._render())
  },

  updated(this: typeof WalletCard & { el: HTMLElement }) {
    this._render()
  },

  destroyed(this: typeof WalletCard) {
    this._root?.unmount()
    this._root = null
  },

  _render(this: typeof WalletCard & { el: HTMLElement }) {
    const d = this.el.dataset
    this._root?.render(
      React.createElement(WalletAttributionCard, {
        coins: parseInt(d.coins ?? "0", 10),
        plan: (d.plan ?? "free") as "free" | "pro",
        compact: d.compact === "true",
      }),
    )
  },
}
